import {
  Constants,
  ContentRendererService,
  LoggerService,
  MgnlContent,
} from '@magnolia/frontend-helpers-base';
import React from 'react';
import { DefaultFallbackComponent } from '../components/DefaultFallbackComponent';
import { ComponentMappings } from '../types';

export const getRenderedComponent = (
  componentContent?: MgnlContent | null,
  componentMappings?: ComponentMappings | null,
  fallbackComponentConfig?:
    | (() => React.ElementType | boolean | null | undefined)
    | boolean
    | null
    | undefined,
  index = 0
): React.ReactElement => {
  const emptyComponent = React.createElement('div');
  if (!componentContent) {
    const errorMsg = `Component content is null or undefined`;
    LoggerService.error(errorMsg);
    return emptyComponent;
  }

  if (!componentContent[Constants.TEMPLATE_ID_PROP]) {
    const errorMsg = `Component content is missing`;
    LoggerService.error(errorMsg);
    return emptyComponent;
  }

  if (!componentMappings) {
    const errorMsg = `Component mappings is null or undefined`;
    LoggerService.error(errorMsg);
    return emptyComponent;
  }

  let componentClass: JSX.Element | React.ElementType =
    componentMappings[componentContent[Constants.TEMPLATE_ID_PROP] as string];
  let isFallbackComponent = false;
  if (!componentClass) {
    const msg = `Component with ID ${componentContent[Constants.TEMPLATE_ID_PROP]} is not mapped.`;
    LoggerService.error(msg);
    const fallbackComponent = getFallbackComponent(fallbackComponentConfig);
    if (!fallbackComponent) {
      return emptyComponent;
    }
    componentClass = fallbackComponent;
    isFallbackComponent = true;
  }
  return React.createElement(
    componentClass as React.ComponentType<unknown>,
    ContentRendererService.buildComponentProperties(
      componentContent,
      undefined,
      index,
      isFallbackComponent
    )
  );
};

function getFallbackComponent(
  fallbackComponentConfig:
    | (() => React.ElementType | boolean | null | undefined)
    | boolean
    | null
    | undefined
): React.ElementType | null | undefined {
  let fallbackComponent: React.ElementType | boolean | null | undefined = null;
  if (typeof fallbackComponentConfig === 'function') {
    fallbackComponent = fallbackComponentConfig();
  } else {
    fallbackComponent = fallbackComponentConfig;
  }
  if (typeof fallbackComponent === 'boolean' && fallbackComponent) {
    fallbackComponent = DefaultFallbackComponent as React.FunctionComponent;
  } else if (!fallbackComponent) {
    fallbackComponent = null;
  }
  return fallbackComponent;
}
